import authrequest from '@/utils/authrequest'

const PATIENT_PAYMENT_PROGRESS_URL = '/api/app/patient-payment-progress'
const PATIENT_PAYMENT_PROGRESS_STATUS_URL = `${PATIENT_PAYMENT_PROGRESS_URL}/status`
const PATIENT_PAYMENT_PROGRESS_SETL_ID_URL = `${PATIENT_PAYMENT_PROGRESS_URL}/setl-id`
const PATIENT_PAYMENT_URL = '/api/app/patient-payment'
const PATIENT_PAYMENT_DETAIL_URL = '/api/app/patient-payment-detail'
const INSURANCE_RECONCILIATION_SUMMARY_URL = `${PATIENT_PAYMENT_URL}/insurance-reconciliation-summary`
const ORDER_URL = '/api/app/order'

export function listPatientPaymentProgress(params) {
  return authrequest({
    url: PATIENT_PAYMENT_PROGRESS_URL,
    method: 'get',
    params
  })
}

export function listPatientPayments(params) {
  return authrequest({
    url: PATIENT_PAYMENT_URL,
    method: 'get',
    params
  })
}

export function getPatientPayment(id) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/${id}`,
    method: 'get'
  })
}

export function updatePatientPayment(id, data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/${id}`,
    method: 'put',
    data
  })
}

export function createPatientPaymentProgress(data) {
  return authrequest({
    url: PATIENT_PAYMENT_PROGRESS_URL,
    method: 'post',
    data
  })
}

export function updatePatientPaymentProgress(id, data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_PROGRESS_URL}/${id}`,
    method: 'put',
    data
  })
}

export function updatePatientPaymentProgressStatus(data) {
  return authrequest({
    url: PATIENT_PAYMENT_PROGRESS_STATUS_URL,
    method: 'put',
    data
  })
}

export function updatePatientPaymentProgressSetlId(data) {
  return authrequest({
    url: PATIENT_PAYMENT_PROGRESS_SETL_ID_URL,
    method: 'put',
    data
  })
}

export function createPatientPayment(data) {
  return authrequest({
    url: PATIENT_PAYMENT_URL,
    method: 'post',
    data
  })
}

export function createOrder(data) {
  return authrequest({
    url: ORDER_URL,
    method: 'post',
    data
  })
}

/**
 * 锁定/解锁医嘱和处方（防止收费期间医生改动）
 * @param {Object} data - { sourceItems: [{ SourceType, SourceId }], isLocking: boolean }
 * @returns {Promise}
 */
export function setChargeLocking(data) {
  return authrequest({
    url: `${ORDER_URL}/set-charge-locking`,
    method: 'post',
    data
  })
}

/**
 * 按 PsnNo、SetlId、MdtrtId 查询费用明细列表（用于开发票展示）
 * @param {Object} params - 查询参数
 * @param {string} [params.psnNo] - 人员编号
 * @param {string} [params.setlId] - 结算ID
 * @param {string} [params.mdtrtId] - 就诊ID
 * @returns {Promise<Array>} PatientPaymentDetailDto[]
 */
export function getPatientPaymentDetailsByKeys(params) {
  return authrequest({
    url: `${PATIENT_PAYMENT_DETAIL_URL}/by-keys`,
    method: 'get',
    params
  })
}

/**
 * 按多组 (PsnNo, SetlId, MdtrtId) 一次性批量查询费用明细
 * @param {Array<{psnNo: string, setlId: string, mdtrtId: string}>} items
 * @returns {Promise<Array>} PatientPaymentDetailDto[]（展平，前端按 SetlId 分组）
 */
export function batchListPatientPaymentDetailsByKeys(items) {
  return authrequest({
    url: `${PATIENT_PAYMENT_DETAIL_URL}/batch-list-by-keys`,
    method: 'post',
    data: { items }
  })
}

/**
 * 批量写入费用明细（5204 feedetail 入库）
 * @param {Object} data - { psnNo, setlId, mdtrtId, details }
 * @param {Array} data.details - 费用明细项（camelCase，与 Report5204FeeDetail 字段对应）
 */
export function batchInsertPatientPaymentDetails(data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_DETAIL_URL}/batch-insert`,
    method: 'post',
    data
  })
}

/**
 * 为缴费明细绑定药品批次（用于无出库单的缴费明细手动绑定批次信息）
 * @param {Object} data - { paymentDetailId, medicineBatchId }
 * @returns {Promise<void>}
 */
export function bindPaymentDetailBatch(data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_DETAIL_URL}/bind-batch`,
    method: 'post',
    data
  })
}

/**
 * 医保对账数据补录（根据对账明细从医保拉取费用并创建缴费记录）
 * @param {Object} data - { psnNo, setlId, mdtrtId, medfeeSumamt, fundPaySumamt, acctPay, details }
 * @returns {Promise<Object>} PatientPaymentDto
 */
export function repairFromInsurance(data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/repair-from-insurance`,
    method: 'post',
    data
  })
}

/**
 * 根据结算ID查询关联的处方编号和医嘱编号
 * @param {string} setlId - 结算ID
 */
export function getLinkedSourceNosBySetlId(setlId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/linked-source-nos-by-setl-id`,
    method: 'get',
    params: { setlId }
  })
}

/**
 * 根据人员编号和结算日期推算关联的处方编号和医嘱编号
 * @param {string} psnNo - 人员编号
 * @param {string} setlDate - 结算日期 yyyy-MM-dd
 */
export function getLinkedSourceNosByPsnNoAndDate(psnNo, setlDate) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/linked-source-nos-by-psn-no-and-date`,
    method: 'get',
    params: { psnNo, setlDate }
  })
}

/**
 * 作废补录支付记录
 * @param {Object} data - { statementDetailId }
 */
export function voidInsuranceRepair(data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/void-insurance-repair`,
    method: 'post',
    data
  })
}

export function getReconciliationList(params) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/reconciliation-list`,
    method: 'get',
    params
  })
}

export function getInsuranceReconciliationSummary(params) {
  return authrequest({
    url: INSURANCE_RECONCILIATION_SUMMARY_URL,
    method: 'get',
    params
  })
}

/**
 * 下载对账明细文件（ZIP）
 * @param {Object} data - { insutypes, clrTypes, statementBeginDate, statementEndDate }
 * @returns {Promise<Blob>} ZIP文件
 */
export function downloadReconciliationDetail(data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/download-insurance-reconciliation-detail`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}

/**
 * 上传对账ZIP文件到后端（multipart/form-data）
 * @param {Blob|File} file - ZIP压缩文件
 * @param {string} statementDate - 对账日期（yyyy-MM-dd）
 * @param {string} [clrOptins] - 结算经办机构
 * @param {string} [insutype] - 险种
 * @param {string} [clrType] - 清算类别
 * @returns {Promise<string>} 对账主表ID（Guid）
 */
export function uploadInsuranceStatement(file, statementDate, clrOptins, clrType) {
  const formData = new FormData()
  formData.append('file', file, 'reconciliation.zip')
  formData.append('statementDate', statementDate)
  if (clrOptins) formData.append('clrOptins', clrOptins)
  if (clrType) formData.append('clrType', clrType)
  return authrequest({
    url: '/api/his/upload/insurance-statement',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 对账记录分页列表（主表）
 * @param {Object} params
 * @param {string} [params.statementDateBegin] - 对账日期起
 * @param {string} [params.statementDateEnd] - 对账日期止
 * @param {string} [params.sorting]
 * @param {number} params.skipCount
 * @param {number} params.maxResultCount
 * @returns {Promise<{totalCount: number, items: Array}>}
 */
export function getInsuranceStatementList(params) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/insurance-statement-list`,
    method: 'get',
    params
  })
}

/**
 * 获取3101事前分析入参（在2203提交缴费单之后调用）
 * @param {string} progressId - 收费流程ID
 * @returns {Promise<Report3101ParamsDto>} 3101入参
 */
export function getReport3101Input(progressId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/report3101Input/${progressId}`,
    method: 'get'
  })
}

/**
 * 获取3102事中分析入参（在2206结算之后调用）
 * @param {string} paymentId - 缴费主表ID
 * @returns {Promise<Report3102ParamsDto>} 3102入参
 */
export function getReport3102Input(paymentId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/report3102Input/${paymentId}`,
    method: 'get'
  })
}

/**
 * 获取缴费记录的3505溯源码上报参数列表
 * @param {string} paymentId - 缴费主表ID
 * @returns {Promise<Array>} 3505参数列表
 */
export function getReport3505Items(paymentId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/report3505Items/${paymentId}`,
    method: 'get'
  })
}

/**
 * 更新溯源码上报状态为已上报
 * @param {string} paymentId - 缴费主表ID
 */
export function updateTraceReportStatus(paymentId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/trace-report-status/${paymentId}`,
    method: 'put'
  })
}

export function markTraceNotRequired(paymentId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/mark-trace-not-required/${paymentId}`,
    method: 'post'
  })
}

/**
 * 批量查询溯源码补录数据（根据结算ID和药品医保编码列表）
 * @param {Array<{setlId: string, medListCodg: string}>} items - 结算ID和药品医保编码列表
 * @returns {Promise<Array>} 匹配结果列表
 */
export function batchTraceReportQuery(items) {
  return authrequest({
    url: '/api/his/trace-report/batch-query',
    method: 'post',
    data: { items }
  })
}

/** 查询指定追溯码的上报记录，由使用者明确选择一条。 */
export function get3505Records(params) {
  return authrequest({
    url: '/api/his/trace-report/3505-records',
    method: 'get',
    params
  })
}

/** 按所选日志标识回查原始上报，禁止自动选取最近一条。 */
export function findOriginal3505ByTraceCode(traceCode, traceId) {
  return authrequest({
    url: '/api/his/trace-report/find-3505-by-trace-code',
    method: 'get',
    params: { traceCode, traceId }
  })
}

/**
 * 溯源码查询：分页列出出库明细溯源码，聚合关联的医嘱/处方、收费信息、
 * 是否上传（3505）、上传时间、出库单号。
 * @param {Object} params
 * @param {string} [params.traceCode] - 溯源码（模糊）
 * @param {string} [params.stockOutNo] - 出库单号（模糊）
 * @param {number} params.skipCount
 * @param {number} params.maxResultCount
 * @param {string} [params.sorting]
 * @returns {Promise<{totalCount:number, items:Array}>}
 */
export function getTraceCodeQueryList(params) {
  return authrequest({
    url: '/api/app/trace-code-query',
    method: 'get',
    params
  })
}

/**
 * 查询单个溯源码关联的全部出库记录（一对多，供「查看详情」模态展示）
 * @param {string} traceCode - 溯源码
 * @returns {Promise<Array>} 出库记录列表（出库单号/出库时间/来源/收费/本次次数）
 */
export function getTraceCodeDetailRecords(traceCode) {
  return authrequest({
    url: '/api/app/trace-code-query/detail-records',
    method: 'get',
    params: { traceCode }
  })
}

/**
 * 补录出库单（不扣库存，仅建立数据关联，用于溯源码上报）
 * @param {string} paymentId - 缴费记录ID
 * @returns {Promise<number>} 补录的出库单数量
 */
export function supplementStockOut(paymentId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/supplement-stock-out/${paymentId}`,
    method: 'post'
  })
}

/**
 * 删除对账记录（逻辑删除）
 * @param {string} id - 对账主表ID
 * @returns {Promise<void>}
 */
export function deleteInsuranceStatement(id) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/${id}/insurance-statement`,
    method: 'delete'
  })
}

/**
 * 对账明细分页列表
 * @param {Object} params
 * @param {string} params.statementId - 对账主表ID（必填）
 * @param {string} [params.psnNo] - 人员编号（模糊）
 * @param {string} [params.mdtrtId] - 就诊ID（模糊）
 * @param {string} [params.setlId] - 结算ID（模糊）
 * @param {string} [params.msgid] - 发送方报文ID（模糊）
 * @param {string} [params.stmtRslt] - 对账结果代码，精确匹配（0=平,1=中心多,2=医药机构多,3=数据不一致）
 * @param {boolean|null} [params.isRefunded] - true=已退费, false=未退费, null=不筛选
 * @param {boolean|null} [params.isMatched] - true=已匹配缴费记录, false=未匹配, null=不筛选
 * @param {string} [params.sorting] - 排序
 * @param {number} params.skipCount
 * @param {number} params.maxResultCount
 * @returns {Promise<{totalCount: number, items: Array}>}
 */
export function getInsuranceStatementDetailList(params) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/insurance-statement-detail-list`,
    method: 'get',
    params
  })
}

/**
 * 获取医保调用日志（按 progressId 查询）
 * @param {string} progressId - 收费流程ID
 * @returns {Promise<Array>} 日志列表 [{ progressId, patientId, paymentId, infno, inputJsonText, responseJsonText, requestDurationMs, creationTime }]
 */
export function getInsuranceTraceLogsByProgressId(progressId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_PROGRESS_URL}/trace-list-by-progress-id/${progressId}`,
    method: 'get'
  })
}

/**
 * 获取医保调用日志（按 paymentId 查询）
 * @param {string} paymentId - 缴费记录ID
 * @returns {Promise<Array>} 日志列表，字段同 getInsuranceTraceLogsByProgressId
 */
export function getInsuranceTraceLogsByPaymentId(paymentId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_PROGRESS_URL}/trace-list-by-payment-id/${paymentId}`,
    method: 'get'
  })
}

/**
 * 全局医保调用日志分页查询
 * @param {Object} params
 * @param {string} [params.infno] 医保接口号（精确）
 * @param {string} [params.mdtrtId] 就诊ID（在入参/出参 JSON 模糊匹配）
 * @param {string} [params.setlId] 结算ID
 * @param {string} [params.psnNo] 人员编号
 * @param {string} [params.keyword] 通用关键词
 * @param {string} [params.patientId] 患者ID（精确）
 * @param {string} [params.paymentId] 缴费ID（精确）
 * @param {string} [params.progressId] 流程ID（精确）
 * @param {string} [params.creationTimeBegin] 起始时间 yyyy-MM-dd HH:mm:ss
 * @param {string} [params.creationTimeEnd] 结束时间
 * @param {number} [params.skipCount]
 * @param {number} [params.maxResultCount]
 * @param {string} [params.sorting]
 */
export function getInsuranceTraceLogList(params) {
  return authrequest({
    url: `${PATIENT_PAYMENT_PROGRESS_URL}/trace-log-list`,
    method: 'get',
    params
  })
}

/**
 * 获取单条医保调用日志详情（含完整入参/出参 JSON）
 * @param {string} id - trace 主键
 */
export function getInsuranceTraceLogDetail(id) {
  return authrequest({
    url: `${PATIENT_PAYMENT_PROGRESS_URL}/${id}/trace-log-detail`,
    method: 'get'
  })
}

/**
 * 追加医保调用日志（独立落盘接口，失败前端静默忽略，不阻塞收费流程）。
 * @param {Object} payload
 * @param {string} [payload.progressId]
 * @param {string} [payload.patientId]
 * @param {string} [payload.paymentId]
 * @param {string} [payload.infno] - 医保接口号：2201/2204/2206/2207/4101/5204 等
 * @param {string} payload.traceStr - EasyHis 响应体中的 ybApiTrace 字段密文
 */
export function appendInsuranceTrace(payload) {
  return authrequest({
    url: `${PATIENT_PAYMENT_PROGRESS_URL}/append-trace`,
    method: 'post',
    data: payload
  })
}

/**
 * 解密 ybApiTrace 密文，返回明文请求/响应（仅用于"复制参数"按钮）。
 * @param {Object} payload
 * @param {string} payload.traceStr - EasyHis 响应体中的 ybApiTrace 字段密文
 * @returns {Promise<{inputJsonText: string, responseJsonText: string, requestDurationMs: number}>}
 */
export function decryptInsuranceTrace(payload) {
  return authrequest({
    url: `${PATIENT_PAYMENT_PROGRESS_URL}/decrypt-trace`,
    method: 'post',
    data: payload
  })
}

/**
 * 查询清算经办机构为空的缴费记录
 * @param {Object} params - { beginDate, endDate }
 * @returns {Promise<Array>} 缴费记录列表
 */
export function getPaymentsWithEmptyClrOptins(params) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/payments-with-empty-clr-optins`,
    method: 'get',
    params
  })
}

/**
 * 更新缴费记录的清算经办机构 / 清算类别
 * 后端 UpdateClrOptinsInput 接受 { id, clrOptins?, clrType? }，传哪个改哪个；不传保持原值
 * @param {Object} data - { id, clrOptins?, clrType? }
 * @returns {Promise}
 */
export function updatePaymentClrOptins(data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/clr-optins`,
    method: 'put',
    data
  })
}

/**
 * 获取缴费记录费用汇总（按状态分组）
 */
export function getPaymentSummary(params) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/payment-summary`,
    method: 'get',
    params
  })
}

/** 按金额项查询结算明细，合计覆盖全部筛选结果，记录由后端分页。 */
export function getPaymentAmountDetails(params) {
  return authrequest({ url: `${PATIENT_PAYMENT_URL}/amount-details`, method: 'get', params })
}


/**
 * 开票汇总预览：按当前查询条件汇总（不受分页/勾选限制），仅统计"已结算"记录，
 * 后端按患者分组返回耗材费/药品费/治疗费的费用归类。
 * @param {Object} params 与列表查询一致的过滤条件
 */
export function getInvoiceSummary(params) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/invoice-summary`,
    method: 'get',
    params
  })
}

/**
 * 获取缴费关联的治疗日期
 */
export function getTreatmentDate(paymentId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/treatment-date/${paymentId}`,
    method: 'get'
  })
}

/**
 * 补生成开票明细
 */
export function regeneratePaymentDetails(paymentId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/regenerate-payment-details/${paymentId}`,
    method: 'post'
  })
}

/**
 * 重新获取开票信息
 */
export function refreshInvoiceInfo(paymentId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/refresh-invoice-info/${paymentId}`,
    method: 'post'
  })
}

/**
 * 批量重新获取开票信息
 */
export function batchRefreshInvoiceInfo(paymentIds) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/batch-refresh-invoice-info`,
    method: 'post',
    data: paymentIds
  })
}

/**
 * 清除发票信息
 */
export function clearInvoiceInfo(paymentId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/clear-invoice-info/${paymentId}`,
    method: 'post'
  })
}

/**
 * 关联发票：手动填写流水号后拉取发票信息
 */
export function linkInvoice(paymentId, data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/link-invoice/${paymentId}`,
    method: 'post',
    data
  })
}

/**
 * 导出缴费记录列表
 */
export function hisExportPatientPayments(data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/export`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}

/**
 * 重置结算失败的收费记录
 */
export function resetSettleFailed(data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/reset-settle-failed`,
    method: 'post',
    data
  })
}

// ========== 清算申请记录 ==========

/** 保存清算申请记录 */
export function saveSettlementApply(data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/save-settlement-apply`,
    method: 'post',
    data
  })
}

/** 撤销清算申请 */
export function cancelSettlementApply(data) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/cancel-settlement-apply`,
    method: 'post',
    data
  })
}

/** 获取清算申请记录列表 */
export function getSettlementApplyList(params) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/settlement-apply-list`,
    method: 'get',
    params
  })
}

/** 使用储值卡支付缴费记录的现金自付部分 */
export function payCashByStoredValueCard(paymentId) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/pay-cash-by-stored-value-card/${paymentId}`,
    method: 'post'
  })
}

/**
 * 获取患者上一次的慢病诊断
 * @param {string} psnNo - 人员编号
 * @returns {Promise<{diseaseCode: string, diseaseName: string} | null>} 上次慢病诊断信息
 */
export function getLastChronicDisease(psnNo) {
  return authrequest({
    url: `${PATIENT_PAYMENT_URL}/last-chronic-disease`,
    method: 'get',
    params: { psnNo }
  })
}

export function getPatientPeriodCost(params) {
  return authrequest({ url: '/api/app/patient-payment/period-cost', method: 'get', params })
}

/** 按费用汇总筛选条件一次查询超限价明细。 */
export function getPaymentOverlimitDetails(params) {
  return authrequest({ url: `${PATIENT_PAYMENT_URL}/overlimit-details`, method: 'get', params })
}
